<div class="breadcrumb-container general-container" [ngClass]="font?.size">
  <p class="path-name" [ngClass]="font?.size" *ngFor="let name of pathNames">{{ name | translate }}</p>
</div>
